import React from "react";
import { motion } from "framer-motion";

const fadeUp = {
  hidden: { opacity: 0, y: 28 },
  visible: { opacity: 1, y: 0, transition: { duration: 0.6, ease: "easeOut" as const } },
};

const stagger = {
  hidden: {},
  visible: { transition: { staggerChildren: 0.1, delayChildren: 0.1 } },
};

const LightCard = ({ children, style }: { children: React.ReactNode; style?: React.CSSProperties }) => (
  <div style={{ background: "#ffffff", border: "1px solid rgba(45,106,20,0.12)", borderRadius: 16, padding: "1.75rem", boxShadow: "0 2px 20px rgba(0,0,0,0.055)", ...style }}>
    {children}
  </div>
);

const VolunteerWithUs: React.FC = () => (
  <div>
    {/* HERO */}
    <section style={{ background: "linear-gradient(135deg, #0a2605 0%, #0d1b2a 55%, #150308 100%)", padding: "5rem 1.5rem 6rem", position: "relative", overflow: "hidden" }}>
      <div style={{ position: "absolute", top: -120, right: -120, width: 440, height: 440, borderRadius: "50%", background: "radial-gradient(circle, rgba(109,199,68,0.18) 0%, transparent 70%)", pointerEvents: "none" }} />
      <div style={{ position: "absolute", bottom: -100, left: -100, width: 380, height: 380, borderRadius: "50%", background: "radial-gradient(circle, rgba(198,37,45,0.12) 0%, transparent 70%)", pointerEvents: "none" }} />
      <div style={{ maxWidth: 780, margin: "0 auto", position: "relative", zIndex: 1 }}>
        <motion.div variants={stagger} initial="hidden" animate="visible">
          <motion.span variants={fadeUp} style={{ display: "inline-flex", alignItems: "center", gap: 8, background: "rgba(109,199,68,0.12)", border: "1px solid rgba(109,199,68,0.3)", borderRadius: 999, padding: "0.35rem 1rem", color: "#6dc744", fontSize: "0.82rem", fontWeight: 700, letterSpacing: "0.08em", textTransform: "uppercase", marginBottom: "1rem" }}>
            <span style={{ width: 7, height: 7, background: "#6dc744", borderRadius: "50%", display: "inline-block" }} />
            Support the Market
          </motion.span>
          <motion.h1 variants={fadeUp} style={{ fontSize: "clamp(2.4rem, 5.5vw, 4rem)", fontWeight: 900, color: "white", lineHeight: 1.08, marginBottom: "1.25rem" }}>
            Volunteer{" "}
            <span style={{ background: "linear-gradient(90deg, #6dc744, #c6252d)", WebkitBackgroundClip: "text", WebkitTextFillColor: "transparent" }}>
              With Us
            </span>
          </motion.h1>
          <motion.p variants={fadeUp} style={{ fontSize: "1.15rem", color: "rgba(255,255,255,0.72)", lineHeight: 1.7, maxWidth: 560 }}>
            Give your time, strengthen your community, and promote sustainable local food systems.
          </motion.p>
        </motion.div>
      </div>
    </section>

    {/* CONTENT */}
    <section style={{ background: "#fffdf8", padding: "4rem 1.5rem" }}>
      <div style={{ maxWidth: 780, margin: "0 auto" }}>
        <motion.div initial="hidden" whileInView="visible" viewport={{ once: true }} variants={stagger}>
          <motion.div variants={fadeUp}>
            <LightCard style={{ borderTop: "4px solid #6dc744" }}>
              <div style={{ fontSize: "2.5rem", marginBottom: "0.75rem" }}>🙌</div>
              <p style={{ color: "#444", lineHeight: 1.75, fontSize: "1.1rem", marginBottom: "0.75rem" }}>
                Volunteering is a great way to support the St. John's Farmers' Market! By giving your time, you'll help strengthen our community and promote sustainable food systems.
              </p>
              <p style={{ color: "#444", lineHeight: 1.75, fontSize: "1.1rem", marginBottom: "1.25rem" }}>
                Interested in volunteering? Click the button below to email us and get started!
              </p>
              <a
                href="mailto:volunteer@sjfm.ca"
                style={{ background: "linear-gradient(135deg, #2d6a14, #4a8c25)", color: "white", borderRadius: 999, padding: "0.9rem 2.2rem", fontWeight: 700, fontSize: "1rem", textDecoration: "none", display: "inline-block", boxShadow: "0 4px 20px rgba(45,106,20,0.3)", transition: "transform 0.2s, box-shadow 0.2s" }}
                onMouseEnter={(e) => { e.currentTarget.style.transform = "translateY(-2px)"; e.currentTarget.style.boxShadow = "0 8px 28px rgba(45,106,20,0.45)"; }}
                onMouseLeave={(e) => { e.currentTarget.style.transform = "translateY(0)"; e.currentTarget.style.boxShadow = "0 4px 20px rgba(45,106,20,0.3)"; }}
              >
                Become a Volunteer →
              </a>
            </LightCard>
          </motion.div>
        </motion.div>
      </div>
    </section>
  </div>
);

export default VolunteerWithUs;
